import { FormControl, Select, Spinner, Stack } from '@chakra-ui/react'
import { Vinkulant } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { Controller, useFormContext } from 'react-hook-form'
import { Datepicker } from '../components/Datepicker'
import { FormGroup } from '../components/FormGroup'
import { FormLabel } from '../components/FormLabel'
import { InputGroup } from '../components/InputGroup'
import { useSelections } from '../hooks'
import { useNameof } from '../hooks/useNameof'

const InsureeVinkulant = ({ vinkulantPrefix, isDisabled }: { vinkulantPrefix: string, isDisabled?: boolean }) => {
    const nameof = useNameof<Vinkulant>(vinkulantPrefix)
    const { register, getValues, setValue, watch, control } = useFormContext()
    const { data: vinkulants, isLoading: isLoadingVinkulants, isFetching: isFetchingVinkulants } = useSelections(SelectionType.Vinkulant)
    const { data: vinkulantTypes, isLoading: isLoadingVinkulantTypes, isFetching: isFetchingVinkulantTypes } = useSelections(SelectionType.VinkulationType)

    const creditorId = watch(nameof(x => x.creditorId))

    return (
        <>
            <FormControl variant='fullWidth' isRequired>
                <Stack direction={'row'}>
                    <FormLabel tooltip="Vyberte název vinkulanta/leasingové společnosti. Pokud není v seznamu, vyberte položku Jiný a název uveďte do pole Bližší specifikace.">
                        Vinkulant
                    </FormLabel>
                    {(isLoadingVinkulants || isFetchingVinkulants) && <Spinner />}
                </Stack>

                <Controller
                    name={nameof(x => x.creditorId)}
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <Select value={value} onChange={onChange} isDisabled={isDisabled}>
                            <option value=''>Vyberte</option>
                            {vinkulants?.data.map((item) => (
                                <option value={item.value} key={item.value}>
                                    {item.description}
                                </option>
                            ))}
                        </Select>
                    )}
                />
            </FormControl>

            {creditorId == '00000035' && <FormControl variant='fullWidth'>
                <FormLabel tooltip="Zde zadejte název vinkulanta/leasingové společnosti, pokud není v seznamu">Bližší specifikace</FormLabel>
                <InputGroup {...register(nameof(x => x.creditorName))} isDisabled={isDisabled} />
            </FormControl>}

            <FormGroup>
                <FormControl isRequired>
                    <FormLabel>IČO</FormLabel>
                    <InputGroup {...register(nameof(x => x.creditorIc))} isDisabled={isDisabled} />
                </FormControl>

                <FormControl>
                    <Stack direction={'row'}>
                        <FormLabel tooltip="Vyberte typ vinkulace ze seznamu">Typ vinkulace</FormLabel>
                        {(isLoadingVinkulantTypes || isFetchingVinkulantTypes) && <Spinner />}
                    </Stack>

                    <Controller
                        name={nameof(x => x.vinkulationType)}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Select value={value} onChange={onChange} isDisabled={isDisabled}>
                                <option disabled value=''>Vyberte</option>
                                {vinkulantTypes?.data.map((item) => (
                                    <option value={item.value} key={item.value}>
                                        {item.description}
                                    </option>
                                ))}
                            </Select>
                        )}
                    />


                </FormControl>
            </FormGroup>

            <FormGroup>

                <FormControl>
                    <FormLabel>Číslo smlouvy</FormLabel>
                    <InputGroup {...register(nameof(x => x.policyNumber))} isDisabled={isDisabled} />
                </FormControl>

            </FormGroup>


            <FormGroup>
              <FormControl>
                <FormLabel tooltip='Zadejte datum počátku leasingové smlouvy'>Datum počátku smlouvy</FormLabel>
                <Datepicker
                  isDisabled={isDisabled}
                  date={getValues(nameof(x => x.policyStartDate))}
                  onDateChange={(date) => setValue(nameof(x => x.policyStartDate), date)}
                />
              </FormControl>
              <FormControl>
                <FormLabel tooltip='Zadejte datum konce leasingové smlouvy'>Datum konce smlouvy</FormLabel>
                <Datepicker
                  isDisabled={isDisabled}
                  date={getValues(nameof(x => x.policyEndDate))}
                  onDateChange={(date) => setValue(nameof(x => x.policyEndDate), date)}
                />
              </FormControl>
            </FormGroup>


            <FormGroup>
                <FormControl>
                    <FormLabel>Obec</FormLabel>
                    <InputGroup {...register(nameof(x => x.creditorCity))} isDisabled={isDisabled} />
                </FormControl>

                <FormControl>
                    <FormLabel>Ulice a číslo</FormLabel>
                    <InputGroup {...register(nameof(x => x.creditorStreet))} isDisabled={isDisabled} />
                </FormControl>

                <FormControl>
                    <FormLabel>PSČ</FormLabel>
                    <InputGroup htmlSize={6} {...register(nameof(x => x.creditorPostCode))} isDisabled={isDisabled} />
                </FormControl>
            </FormGroup>
        </>
    )
}

export default InsureeVinkulant